import { render, staticRenderFns } from "./KnowledgeContentFolderView.vue?vue&type=template&id=06aae96a&"
import script from "./KnowledgeContentFolderView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentFolderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports